import "../../css/admin/ModalAdmin.css";
import React, { Component } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose,faTimesCircle, faCheckCircle  } from '@fortawesome/free-solid-svg-icons';
import logo from "../../assets/logo_espol_interno.svg";


export class ModalAdmin extends Component {
    render() {
        return (
          <div className="modalAdmin-background">
            <div className="modalAdmin-container">
              <div className="modalAdmin-header1">
                <img className='modalAdmin-logo' src={logo} alt="Logo espol" ></img>
                <button className="modalAdmin-close" onClick={this.props.cerrarModal} >
                  <FontAwesomeIcon icon={faWindowClose}></FontAwesomeIcon>
                </button>
                <p className="modalAdmin-tituloHeader">{this.props.tituloHeader}</p>
              </div>
              <div className="modalAdmin-body">
                
                {this.props.children}
                
              </div>
              <div className="modalAdmin-container-btn">

                <button className="modalAdmin-botones" onClick={this.props.submit}>
                    <FontAwesomeIcon icon={faCheckCircle} className='modalAdmin-icono-bnt'></FontAwesomeIcon>
                    {this.props.txtBtnSubmit}
                </button>

                <button className="modalAdmin-botones" onClick={this.props.cerrarModal}>
                <FontAwesomeIcon icon={faTimesCircle} className='modalAdmin-icono-bnt'></FontAwesomeIcon>
                {this.props.txtBtnCancel}
                </button>
            </div>
          </div>
          
          
        </div>
        )
    }
}

export default ModalAdmin
